import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "./EventsLanding.css";

const DspFooter = () => {
  return (
    <div>
      {/* Custom Footer */}
      <footer className="events-footer">
        <div className="footer-wave"></div>
        <div className="container-lg">
          <div className="footer-content">
            {/* Contact Section */}
            <div className="footer-top">
              <div className="footer-contact-section">
                <h3 className="footer-title">Contact us</h3>
                <div className="contact-items">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <EmailIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">For any queries</p>
                      <p className="contact-value">service@dspim.com</p>
                    </div>
                  </div>

                  <div className="contact-divider"></div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <PhoneIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">
                        India : 1800-208-4499 / 1800-200-4499
                      </p>
                      <p className="contact-value">
                        International : 044-61360066
                      </p>
                    </div>
                  </div>

                  <div className="contact-divider"></div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <WhatsAppIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">7738000030</p>
                      <p className="contact-value">
                        Say 'Hi' to us on Whatsapp
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-right-section">
                <div className="download-app">
                  <h4 className="download-title">Download our app</h4>
                  <div className="app-buttons">
                    <button
                      className="app-store-btn"
                      onClick={(e) => e.preventDefault()}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                        alt="App Store"
                      />
                    </button>
                    <button
                      className="play-store-btn"
                      onClick={(e) => e.preventDefault()}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Google Play"
                      />
                    </button>
                  </div>
                </div>

                <div className="social-media">
                  <h4 className="social-title">Follow us</h4>
                  <div className="social-icons">
                    <button
                      className="social-icon twitter"
                      aria-label="Twitter"
                      onClick={(e) => e.preventDefault()}
                    >
                      <TwitterIcon />
                    </button>
                    <button
                      className="social-icon instagram"
                      aria-label="Instagram"
                      onClick={(e) => e.preventDefault()}
                    >
                      <InstagramIcon />
                    </button>
                    <button
                      className="social-icon facebook"
                      aria-label="Facebook"
                      onClick={(e) => e.preventDefault()}
                    >
                      <FacebookIcon />
                    </button>
                    <button
                      className="social-icon linkedin"
                      aria-label="LinkedIn"
                      onClick={(e) => e.preventDefault()}
                    >
                      <LinkedInIcon />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-divider"></div>

            <div className="footer-bottom">
              <p className="disclaimer">
                Mutual fund investments are subject to market risks, read all
                scheme related documents carefully.
              </p>
              <button
                className="privacy-link"
                onClick={(e) => e.preventDefault()}
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DspFooter;
